import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { supabase } from "../supabaseClient";
import { loginSuccess, logout } from "../store/action/authAction";

export default function AuthHandler() {
  const dispatch = useDispatch();

  useEffect(() => {
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange(async (event, session) => {
      if (session) {
        // Fetch the latest user data to ensure all metadata is included
        const {
          data: { user },
        } = await supabase.auth.getUser();
        dispatch(loginSuccess(user));
      } else {
        dispatch(logout());
      }
    });

    return () => subscription?.unsubscribe();
  }, [dispatch]);

  return null; // This component doesn't render anything
}
